<template>
  <AppLazySelect
    v-model="selected"
    multiple
    label="Changed by"
    eager
    class="blame-member-filter"
    set-state-on-value-change
    resource="member"
    :fetcher="fetcher"
    style="margin-bottom: 20px"
  >
    <template #item-leading="{ item }">
      <AppAvatar
        v-if="item.avatar"
        :avatar="item.avatar"
        size="speck"
      />
    </template>
    <template #placeholder>All members</template>
  </AppLazySelect>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { ReportsResource } from '~/resources';

export default {
  name: 'ReportBlameMemberFilter',
    props: {
    queryProperty: {
      type: String,
      default: 'blame_users',
      // This is the default For historical reasons.
      // Make 'members' the default in the future when the majority of report queries expect that
    },
    // Extra filter parameters to be sent to the API
    filterParams: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState({
      useLazySelect: 'use_lazy_select',
      organizationId: (state) => state.organization_id || state.organization?.id,
    }),
     ...mapGetters(['reportQuery']),
    // Only for lazy select
    selected: {
      get() {
        const result = [];

        for (const teamOrUserId of this.reportQuery.filters.blame_users || []) {
          if (typeof teamOrUserId === 'number' || !String(teamOrUserId).includes('team:')) {
            result.push(parseInt(teamOrUserId, 10));
          }
        }

        return result;
      },
      set(userIds = []) {
        this.updateSearch({ [this.queryProperty]: userIds });
      },
    },
  },
  methods: {
    ...mapActions(['updateSearch']),
    fetcher(payload) {
      const finalPayload = {
        ...payload,
        ...this.queryParams,
        filters: {
          ...(payload.filters || {}),
          ...this.filterParams,
          removed_after: this.reportStartDate,
        },
      };

      return ReportsResource.members({ organization_id: this.organizationId }, finalPayload, {
        abortReload: true,
      });
    },
  },
};
</script>
